export default [
  { src: 'https://i.ibb.co/Ks4kVQV/business-Insider.webp', height: 45 },
  { src: 'https://i.ibb.co/mJtTfLL/forbes.webp', height: 45 },
  { src: 'https://i.ibb.co/q0jD0Pt/the-new-york-times.webp', height: 45 },
  { src: 'https://i.ibb.co/q1mwn00/usa-today.webp', height: 45 },
];
